import {
  XDamage,
  XImpactSize,
  XOperationType,
  XStatus,
  XWindows,
} from './const';

export interface FreeSlotsWsV2Params {
  /** Si Pose à Dom demandée. Obligatoire si partnerBranch non renseigné  */
  mobileServices?: {
    postalCode: string;
    city: string;
    fitterId?: string;
  };
  /** Si Pose Centre demandée. Obligatoire si mobileServices non renseigné */
  partnerBranch?: {
    /** N° des centres pour la recherche */
    ids: string[];
  };
  /** Type d'operation recommandé*/
  recommendedOperationType: XOperationType;
  /** 1 pour prêt de véhicule, 0 sans  */
  share: 1 | 0;
  /** Spécification du dommage */
  damage: SlotsDamagedGlassV2;
}

export interface FreeSlotsWsV2ResponseSuccess {
  /** Obligatoire si des créneaux à domicile sont retournés */
  mobileService?: InterventionInformationV2;
  /** Obligatoire si des créneaux en centres sont retournés */
  centerService?: InterventionInformationV2;
  /** L'ensemble des slots par garage */
  partnerSlots: PartnerSlotsV2[];
}

export interface FreeSlotWsV2ResponseError {
  status: 'ERROR';
  response: {
    code: string;
    message: string;
  };
}

export interface SlotsDamagedGlassV2 {
  window: { window: XWindows; isAdas?: boolean }[];
  type: XDamage;
  impacts?: SlotsImpactV2[];
}

export interface SlotsImpactV2 {
  size?: XImpactSize;
  isInViewField?: boolean;
  isInEdge?: boolean;
}

export interface InterventionInformationV2 {
  /** Durée d'intervention en minutes */
  interventionDuration: string;
  /** Durée d'immobilisation */
  immobilisationDuration: string;
  /** true si intervention difficile, sinon false */
  isInterventionDifficult: boolean | string;
}

export interface PartnerSlotsV2 {
  /** Si Pose à domicile */
  isMobileServices: boolean;
  /** Information sur le fitter */
  partnerBranch: PartnerBranchV2;
  /** Liste des jours disponibles pour ce fitter */
  days: SlotsDayV2[];
}

export interface PartnerBranchV2 {
  id: string;
  name: string;
  address: string;
  postalCode: string;
  city: string;
}

export interface SlotsDayV2 {
  /** YYYYMMDD */
  day: string;
  status: XStatus;
  /** Obligatoire si status O */
  openingTime?: Date;
  /** Obligatoire si status O */
  closingTime?: Date;
  /** Liste des slots disponibles ce jour */
  availableSlots: SlotV2[];
}

export interface SlotV2 {
  /** Id unique du créneau */
  id: string;
  /** Date de début du créneau */
  start: string | Date;
}
